<template>
  <div
    class="filter-wrapper"
  >
    <div
      v-if="overflowing"
      class="d-inline"
    >
      <b-dropdown
        v-if="index != -1 && index < properties.length"
        ref="tagDropdown"
        right
        class="filter-items mr-1"
        no-caret
        variant="link-secondary"
        size="lg"
      >
        <template #button-content>
          <span
            class="py-25 px-50 more-filters-tag"
          >
            <GjIcon
              name="Moreoptions"
              size="22"
            />
          </span>
        </template>
        <b-dropdown-item
            v-for="(property, propertyIndex) in properties.slice(index)"
            :key="propertyIndex"
          >
          <selected-filter
            :key="'selected-filter-'+propertyIndex"
            :text="property.name"
            :number="hasFilterNumber ? property.selectedFilters.toString() : null"
            class="child-filter-inner"
            @clearFilter="hasSubMenus ? clickedClearFilters(property.name) : clickedClearFilters(propertyIndex + index)"
            @click="hasClickEvent ? clickedFilter(property.name) : null"
          />
        </b-dropdown-item>
      </b-dropdown>
      <selected-filter
        v-for="(property, propertyIndex) in properties.slice(0, index)"
        :key="'selected-filter-'+propertyIndex"
        :text="property.name"
        :number="hasFilterNumber ? property.selectedFilters.toString() : null"
        class="mr-1 child-filter"
        @clearFilter="hasSubMenus ? clickedClearFilters(property.name) : clickedClearFilters(propertyIndex)"
        @click="hasClickEvent ? clickedFilter(property.name) : null"
      />
    </div>
    <div
      class="parent-filter-wrapper"
      v-else>
      <selected-filter
        v-for="(property, propertyIndex) in properties"
        :key="'selected-filter-'+propertyIndex"
        :text="property.name"
        :number="hasFilterNumber ? property.selectedFilters.toString() : null"
        class="mr-1 child-filter"
        @clearFilter="hasSubMenus ? clickedClearFilters(property.name) : clickedClearFilters(propertyIndex)"
        @click="hasClickEvent ? clickedFilter(property.name) : null"
      />
    </div>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import {
  ref, onMounted, watch,
} from '@vue/composition-api'
import SelectedFilter from '@/components/SelectedFilter.vue'

export default {
  components: {
    GjIcon,
    SelectedFilter,
  },
  props: {
    properties: {
      type: [Array, Object],
    },
    widthOffset: {
      type: Number,
      default: 0,
    },
    hasFilterNumber: {
      type: Boolean,
      default: true,
    },
    hasClickEvent: {
      type: Boolean,
      default: true,
    },
    hasSubMenus: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const overflowing = ref(false)
    const index = ref(-1)

    const isOverflow = () => {
      context.root.$nextTick(() => {
        const parent = document.querySelector('.filter-wrapper')
        const maxWidth = document.querySelector('.app-content').clientWidth
        if (parent.offsetWidth + 60 >= maxWidth - props.widthOffset) {
          if (!overflowing.value) {
            index.value = props.properties.length - 1
          }
          overflowing.value = true
        }
      })
    }
    const clickedFilter = filterName => {
      context.emit('clicked', filterName)
    }
    const clickedClearFilters = property => {
      context.emit('cleared', property)
    }

    onMounted(() => {
      isOverflow()
    })
    /* eslint-disable-next-line */
    watch(() => props.properties, (current, previous) => {
      if (props.properties.slice(index.value).length > 0) {
        isOverflow()
      } else {
        overflowing.value = false
        index.value = -1
        isOverflow()
      }
    })

    return {
      clickedFilter,
      overflowing,
      index,
      clickedClearFilters,
    }
  },
}
</script>
<style lang="scss">
 .filter-wrapper {
   display: inline-block;
 }
.tag-item{
  color: #052D61;
  font-size: 14px;
}
.overflow-answers{
  border: 1px #e0e5eb solid;
  border-radius: 20px;
  width: fit-content;
  padding: 4px 8px;
}
.more-filters-tag {
  border: solid 1px #E0E5EB;
  border-radius: 8px !important;
  padding: 2px 0;
  background-color: white;
}
.filter-items {
  span{
    color: #052D61;
  }
  button.dropdown-toggle{
    padding: 0;
  }
  & > ul.dropdown-menu {
    min-width: 30px;
    z-index: 1035 !important;
    & > li > a.dropdown-item {
      padding: 4px 8px !important;
    }
  }
}
</style>
